import {CryptoSliderCard,Wrapper} from "../../components";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import {useQuery} from "@tanstack/react-query";
import {getMarket,getTickers,getCurrencies} from "../../utils/GetData";

function CryptoSlider() {

    const { data: marketData, isLoading: marketDataLoading, error: marketDataError } = useQuery({
        queryKey: 'markets',
        queryFn: getMarket,
    });

    const { data: tickersData, isLoading: tickersDataLoading, error: tickersDataError } = useQuery({
        queryKey: 'tickers',
        queryFn: getTickers,
    });

    const { data: currenciesData, isLoading: currenciesDataLoading, error: currenciesDataError } = useQuery({
        queryKey: 'currencies',
        queryFn: getCurrencies,
    });

    if(marketDataLoading || tickersDataLoading || currenciesDataLoading){
        return (
            <Wrapper>
                <div className="rounded-3xl border border-dark-line overflow-hidden bg-dark-backgroundOnDark backdrop-blur-sm px-8 py-12 -mt-16 flex justify-center items-center">
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-primary animate-pulse"></div>
                        <div className="w-3 h-3 rounded-full bg-primary animate-pulse delay-150"></div>
                        <div className="w-3 h-3 rounded-full bg-primary animate-pulse delay-300"></div>
                        <span className="text-primary ml-2">Yükleniyor...</span>
                    </div>
                </div>
            </Wrapper>
        );
    }

    if(marketDataError || tickersDataError || currenciesDataError){
        return (
            <Wrapper>
                <div className="rounded-3xl border border-dark-line overflow-hidden bg-dark-backgroundOnDark backdrop-blur-sm px-8 py-12 -mt-16 flex justify-center">
                    <div className="text-danger flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <span>Veri yüklenirken bir hata oluştu.</span>
                    </div>
                </div>
            </Wrapper>
        );
    }

    const combinedData = marketData.filter(item => item.state !== 'hidden').map((item) => {
        return {
            ...item,
            ticker: tickersData[item.id]
        }
    })

    const renderSliderCard = (market) => {
        const foundCurrency = currenciesData.find((item) => item.id === market.base_unit);
        const icon = foundCurrency ? foundCurrency.icon_url || "https://gmskripto.com/coin-icons/gms.png" : "https://gmskripto.com/coin-icons/gms.png";

        return(
            <CryptoSliderCard
                data={market}
                icon={icon}
            />
        )
    }

    return(
        <Wrapper>
            <div className="rounded-3xl border border-dark-line overflow-hidden bg-dark-backgroundOnDark/90 backdrop-blur-sm px-8 py-12 -mt-16 relative">
                {/* Dekoratif elementler */}
                <div className="absolute top-0 left-1/4 w-32 h-32 bg-primary/5 rounded-full blur-xl"></div>
                <div className="absolute bottom-0 right-1/4 w-32 h-32 bg-primary/5 rounded-full blur-xl"></div>
                
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-surface-main font-bold text-xl">Popüler Kripto Paralar</h3>
                    <a href="https://exchange.gmskripto.com/markets" className="text-primary text-sm hover:underline">
                        Tüm Piyasalar
                    </a>
                </div>
                
                <Swiper
                    modules={[Autoplay]}
                    breakpoints={{
                        640: {
                            slidesPerView: 1.5,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2.5,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3.5,
                            spaceBetween: 20,
                        },
                    }}
                    loop={true}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                    className="crypto-slider"
                >
                    {
                        combinedData.map((item,index) => (
                            <SwiperSlide key={index}>
                                {renderSliderCard(item)}
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </Wrapper>
    )
}

export {CryptoSlider}
